// extracted by mini-css-extract-plugin
export default {"sign-form":"sign-form_sign-form__f1sSA","iframe-container":"sign-form_iframe-container__UUmvz","error-message-container":"sign-form_error-message-container__E90EK"};